import { APIConfig } from "../config/api";

export const getPdfUrlFromSlug = (slug: string) =>
  `${APIConfig.url}/pages/${slug}/pdf`;
